import styled from "styled-components";

const ProductInfo = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;

const PriceContainer = styled.div`
  padding-top: 18px;
  flex: 0 0 auto;
`;

export { ProductInfo, PriceContainer };
